import {FieldDescriptor} from "../../common/FormField";
import * as Yup from "yup";
import {useGetDropCatNC, useGetDropLivelliNC, useGetDropStatiNC, validationSchemaNC} from "./Services";
import {useGetDipendentiProg, useGetDropProgettiByCodDip} from "../../common/Services";


export  type NCForm = Yup.InferType<typeof validationSchemaNC>

export const useFieldsNC_1 = (): FieldDescriptor<NCForm>[] => {

  return [
    { name: "titolo", label: "Titolo", type: "string", boxSize: "60%", },
   { name: "dataapertura", label: "Data Apertura", type: "date", boxSize: "20%", },
  { name: "datachiusura", label: "Data Chiusura", type: "date", boxSize: "20%", },

  ];
};

export const useFieldsNC_2 = (): FieldDescriptor<NCForm>[] => {
  const {data: DropCatApiResponse} = useGetDropCatNC();
  const {data: DropStatiApiResponse} = useGetDropStatiNC();
  const {data: DropLivelliApiResponse} = useGetDropLivelliNC();

  return [

    {
      name: "idcatnc", label: "Categoria", type: "autocomplete", boxSize: "33%",
      options: () => DropCatApiResponse?.results ?? [], optionLabelKey: "descatnc", optionValueKey: "idcatnc",
    },
    {
      name: "idstatonc", label: "Stato", type: "autocomplete", boxSize: "33%",
      options: () => DropStatiApiResponse?.results ?? [], optionLabelKey: "desstatonc", optionValueKey: "idstatonc",
    },
    {
      name: "idlivellonc", label: "Livello", type: "autocomplete", boxSize: "33%",
      options: () => DropLivelliApiResponse?.results ?? [], optionLabelKey: "deslivellonc", optionValueKey: "idlivellonc",
    },
  ];
};


export const useFieldsNC_3 = (setValue: (name: keyof NCForm, value: any) => void): FieldDescriptor<NCForm>[] => {

  const {data: DropProgettiApiResponse} = useGetDropProgettiByCodDip();
 const { data: DipendentiApiResponse } = useGetDipendentiProg(2, "");

  return [
    {name: "idprog", label: "Progetto", type: "autocomplete", boxSize: "60%",
      options: () => DropProgettiApiResponse?.results ?? [], optionLabelKey: "desprogblocco", optionValueKey: "idprog",
       onChange: (_: any, idprog: any) => {
        if (!idprog) {
          setValue("coddip", "");
          return;
        }

        const project = DropProgettiApiResponse?.results?.find(
          (p: any) => String(p.idprog) === String(idprog)
        );

        const dipValue = project?.ref ?? "NN";

        setValue("coddip", dipValue);
      },
    },

     {
      name: "coddip",
      label: "Dip.",
      boxSize: "30%",
      type: "autocomplete",
      options: () => {
        return DipendentiApiResponse?.results ?? [];
      },
      optionLabelKey: "label",
      optionValueKey: "coddip",
    },


    {name: "auditor", label: "Auditor", type: "string", boxSize: "10%",},
  ];
};

export const useFieldsNC_4 = (): FieldDescriptor<NCForm>[] => [
  { name: "note", label: "Note", type: "textarea", boxSize: "100%", rows: 6, multiline: true, },
];
